import { useEffect, useState } from "react";

const EVT = "app:update";
let pending = false;

export const registerSW = () => {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", async () => {
    let reg;
    try { reg = await navigator.serviceWorker.register("/sw.js"); } catch { return; }
    const watch = (w) => w && w.addEventListener("statechange", () => { if (w.state === "activated" && navigator.serviceWorker.controller) { pending = true; window.dispatchEvent(new Event(EVT)); } });
    reg.addEventListener("updatefound", () => watch(reg.installing));
    setInterval(() => reg.update().catch(() => {}), 30 * 60 * 1000);
    document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") reg.update().catch(() => {}); });
  });
};

export function useUpdateAvailable() {
  const [ready, setReady] = useState(pending);
  useEffect(() => { const h = () => setReady(pending); window.addEventListener(EVT, h); return () => window.removeEventListener(EVT, h); }, []);
  return ready;
}
